<template>
  <div class="d-flex">
    <icons
      v-if="mostrarIcones"
      class="mr-2"
      :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
      :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
      @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
      @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
    />

    <div class="flex-grow-1">
      <v-file-input
        ref="fileInputRef"
        dense
        outlined
        show-size
        multiple
        hide-details
        validate-on-blur
        hint="Máximo 1MB por arquivo"
        accept=".pdf, .jpg, .img, .jpeg"
        :label="label"
        :filled="filled"
        :disabled="disabled"
        :rules="[isRequired]"
        :prepend-icon="null"
        :prepend-inner-icon="icons.mdiPaperclip"
        @change="$emit('input-changed', { value: $event })"
      >
        <template #append-outer>
          <v-tooltip
            top
            color="primary"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                class="cursor-pointer"
                v-on="on"
                @click="exibirAnexos = !exibirAnexos"
              >
                {{ exibirAnexos ? icons.mdiArrowUpThick : icons.mdiArrowDownThick }}
              </v-icon>
            </template>
            <span>Lista de anexos</span>
          </v-tooltip>
        </template>
      </v-file-input>

      <v-expand-transition>
        <v-data-table
          v-if="exibirAnexos"
          hide-default-header
          hide-default-footer
          class="elevation-4"
          no-data-text="Nenhum anexo disponível"
          :items="anexos.list"
          :headers="headers"
          :item-class="cursorPointer"
          @click:row="downloadArquivo"
        >
          <template v-slot:item.nome="{ item }">
            <v-chip
              color="primary"
              outlined
              class="cursor-pointer"
            >
              {{ item.nome }}
            </v-chip>
          </template>
        </v-data-table>
      </v-expand-transition>
    </div>
  </div>
</template>

<script>
import { ref, computed, watchEffect } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import { mdiPaperclip, mdiArrowUpThick, mdiArrowDownThick } from '@mdi/js'
import Icons from './Icons.vue'
import ComponenteBase from './ComponenteBase.vue'
import ComponenteArquivoOptions from '@/models/props/ComponenteArquivoOptions'
import DocumentoService from '@/services/modules/DocumentoService'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,

  props: {
    componenteArquivoOptions: {
      type: ComponenteArquivoOptions,
      default: null,
    },
  },

  setup(props) {
    const isRequired = computed(() => (props.obrigatorio && !props.readonly ? required : true))

    const fileInputRef = ref(null)
    const anexos = ref({ ticketId: 0, componenteId: 0, list: [] })

    const exibirAnexos = ref(false)

    function downloadArquivo(item) {
      if (!item.url) return
      window.open(`${item.url}`)
    }

    async function getFormularioComponenteTicketAnexos(ticketId, componenteId) {
      if (!ticketId || !componenteId) return
      anexos.value.ticketId = ticketId
      anexos.value.componenteId = componenteId
      anexos.value.list = await DocumentoService.getFormularioComponentAnexos(ticketId, componenteId)
      exibirAnexos.value = !!anexos.value.list.length
    }

    watchEffect(async () => {
      if (!props.componenteArquivoOptions) return

      const { ticketId, componenteId, fetchFiles } = props.componenteArquivoOptions

      if (!fetchFiles) {
        anexos.value = { ticketId: 0, componenteId: 0, list: [] }
        exibirAnexos.value = false
        return
      }

      if (anexos.value.ticketId === ticketId && anexos.value.componenteId === componenteId) return

      await getFormularioComponenteTicketAnexos(ticketId, componenteId)
    })

    const headers = [
      { text: 'Nome', value: 'nome' },
      { text: 'Actions', value: 'actions' },
    ]

    return {
      isRequired,
      fileInputRef,
      anexos,
      exibirAnexos,
      downloadArquivo,
      headers,
      icons: {
        mdiPaperclip,
        mdiArrowUpThick,
        mdiArrowDownThick,
      },
      cursorPointer: () => 'cursor-pointer',
    }
  },
}
</script>
